// =============================================================================
// app/src/lib/codigoDoCarrinho.ts — a régua da oferta "salvar no cadastro".
//
// O gerente digita o código do fabricante no item do carrinho (063). Quando a
// peça É cadastrada e o cadastro está SEM código, vale oferecer gravar lá —
// para ele não digitar de novo no próximo pedido. Fora disso, não se oferece:
//  * peça diversa não tem cadastro para receber nada;
//  * cadastro que já tem código não se sobrescreve daqui (é a tela de Cadastro
//    que mostra a peça inteira, e o banco recusa de qualquer forma);
//  * código curto demais não serve de código — o banco usa a mesma régua.
// =============================================================================
import { normCodigo } from './bip';

export function ofereceSalvarNoCadastro(p: {
  productId: string | null;
  codigoNoCadastro: string | null;
  codigoDigitado: string;
}): boolean {
  if (!p.productId) return false;
  if (normCodigo(p.codigoNoCadastro ?? '') !== '') return false;
  return normCodigo(p.codigoDigitado).length >= 3;
}
